import { FunctionComponent } from "react";
import { StaticLabel } from "@pjs/core-ui";
import { ApprovalViewBase } from "../approval-view-base/ApprovalViewBase.component";
import { IApprovalViewProps } from "./interfaces/IApprovalViewProps";

export const ApprovalView: FunctionComponent<IApprovalViewProps> = (props) => {
    return <ApprovalViewBase statusNotice={props.statusNotice} feedback={props.feedback} header={<StaticLabel text={props.labelText} />} />;
};
